import { Component, Input } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { DocumentStatusEnum } from "@models/documents/document-status.enum";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { documentStatusLabels } from './document-status-labels';

@Component({
  selector: 'app-ag-document-status',
  standalone: true,
  imports: [],
  templateUrl: 'ag-document-status.component.html',
  styleUrl: 'ag-document-status.component.scss'
})
export class AgDocumentStatusComponent implements ICellRendererAngularComp {
  @Input() status: DocumentStatusEnum | undefined = DocumentStatusEnum.Draft;

  readonly DocumentStatusEnum = DocumentStatusEnum;
  readonly documentStatusLabels = documentStatusLabels;

  agInit(params: ICellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: ICellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: ICellRendererParams): boolean {
    this.status = params.value as number;
    return true;
  }
}
